var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"error",on:{"click":_vm.onDelete}},[_vm._v("Xoá sự kiện")])}
var staticRenderFns = []

export { render, staticRenderFns }